module.exports = __webpack_public_path__ + "static/media/babyschwimmen.b17eb057.jpg";